module.exports = __webpack_public_path__ + "static/media/img85.eed6dc36.jpg";